import { getAPI } from "./axios-base";

export default class RestResourceModel {
  getModels(params: { skip: number; limit: number }) {
    return getAPI.get("api/rest/v1/models", {
      params: params
    });
  }
  getModel(id: string) {
    return getAPI.get(`api/rest/v1/models/${id}`);
  }
  putModel(id: string, body: any) {
    return getAPI.put(`api/rest/v1/models/${id}`, body);
  }
  getModelsByBrand(
    brandId: string,
    params: {
      skip: number;
      limit: number;
    }
  ) {
    return getAPI.get(`api/rest/v1/models/by-brand/${brandId}`, {
      params: params
    });
  }
  getModelsByBrandAndYear(brandId: string, year: string) {
    return getAPI.get(
      `api/rest/v1/models/get-models-by-brand-year/${brandId}/${year}`
    );
  }
  getModelYearsByBrand(brandId: string) {
    return getAPI.get(`api/rest/v1/models/get-years-by-brand/${brandId}`);
  }
  postModel(body: any) {
    return getAPI.post(`api/rest/v1/models`, body);
  }
}
